/**
 * 车辆类型枚举
 * 与后端 App\Enum\VehicleTypeEnum 保持一致
 */
export const VEHICLE_TYPE = {
  UNDEFINED: 0,       // 未定义
  FLAT_TRUCK: 1,      // 平板车
  CONTAINER_TRUCK: 2, // 货柜车
  TANK_TRUCK: 3,      // 槽罐车
  OTHER: 4,           // 其他
  HIGH_SIDED_TRUCK: 5,// 高栏车
  DUMP_TRUCK: 6,      // 自卸车
  CONTAINER: 7,       // 集装箱
  BOX_TRUCK: 8,       // 厢式车
  LOW_SIDED_TRUCK: 9  // 低栏车
}

/**
 * 车辆类型映射表 { id, name }[]
 * 可直接用于 el-select、van-picker 等组件
 */
export const VEHICLE_TYPE_LIST = [
  { id: VEHICLE_TYPE.FLAT_TRUCK,       name: '平板车' },
  { id: VEHICLE_TYPE.CONTAINER_TRUCK,  name: '货柜车' },
  { id: VEHICLE_TYPE.TANK_TRUCK,       name: '槽罐车' },
  { id: VEHICLE_TYPE.OTHER,            name: '其他' },
  { id: VEHICLE_TYPE.HIGH_SIDED_TRUCK, name: '高栏车' },
  { id: VEHICLE_TYPE.DUMP_TRUCK,       name: '自卸车' },
  { id: VEHICLE_TYPE.CONTAINER,        name: '集装箱' },
  { id: VEHICLE_TYPE.BOX_TRUCK,        name: '厢式车' },
  { id: VEHICLE_TYPE.LOW_SIDED_TRUCK,  name: '低栏车' }
]

/**
 * 根据 id 获取车辆类型名称
 * @param {number|string} id
 * @returns {string}
 */
export function getVehicleTypeLabel(id) {
  const item = VEHICLE_TYPE_LIST.find(v => v.id === Number(id))
  return item ? item.name : '--'
}

/**
 * 根据名称获取车辆类型 id
 * @param {string} name
 * @returns {number|null}
 */
export function getVehicleTypeId(name) {
  const item = VEHICLE_TYPE_LIST.find(v => v.name === name)
  return item ? item.id : null
}
